// extracted by mini-css-extract-plugin
module.exports = {"timelineSection":"clinical-portal-3__TimelineSection__timelineSection"};